export default __webpack_public_path__ + "static/media/action-card-liquidity-mining-btc-dfi.8cf2203c.svg";